import { LabsFlag } from '../enums/labsFlag'
import { useLabsMenuFlags } from './useLabsMenuFlags'

interface ExpertReportsFeature {
  isExpertReportsEnabled: boolean
}

export const useExpertReportsFeature = (): ExpertReportsFeature => {
  const labsFlags = useLabsMenuFlags()
  return { isExpertReportsEnabled: labsFlags[LabsFlag.Reports] }
}
